import { render, staticRenderFns } from "./EditPasswordDialog.vue?vue&type=template&id=45c7e8e6&scoped=true"
import script from "./EditPasswordDialog.vue?vue&type=script&lang=js"
export * from "./EditPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPasswordDialog.vue?vue&type=style&index=0&id=45c7e8e6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7e8e6",
  null
  
)

export default component.exports